import { useLazyAssignment } from '@client/lib/assignments';
import { getCustomerGroup } from '@client/redux/modules/customer';
import { getCookie } from '@pegasus/utils';
import { LoungVisitorActivitySegments } from '@shared/types/customer';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

export interface useLeavingSoonVariantsReturn {
    isLeavingSoonLabel: boolean;
    isLeavingSoonComponent: boolean;
    isAnyLeavingSoonVariant: boolean;
}

export const useLeavingSoonVariants = (): useLeavingSoonVariantsReturn => {
    const customerGroup = useSelector(getCustomerGroup);
    const isDailyUser = !!(
        customerGroup &&
        customerGroup.lounge_visitor_activity_segments === LoungVisitorActivitySegments.DAILY
    );
    const [assignment, fetchAssignmentOrPostFeedback] = useLazyAssignment('engage_leaving_soon');

    const isLeavingSoonLabel =
        assignment?.variant === 'variant_leaving_soon_label' ||
        getCookie('isLeavingSoonLabel') === 'true';

    const isLeavingSoonComponent =
        assignment?.variant === 'variant_leaving_soon_component' ||
        getCookie('isLeavingSoonComponent') === 'true';
    const isAnyLeavingSoonVariant = !isDailyUser && (isLeavingSoonLabel || isLeavingSoonComponent);

    useEffect(() => {
        if (!isDailyUser) {
            fetchAssignmentOrPostFeedback();
        }
    }, [isDailyUser, fetchAssignmentOrPostFeedback]);

    return {
        isLeavingSoonLabel,
        isLeavingSoonComponent,
        isAnyLeavingSoonVariant,
    };
};
